import usePrivateAxios from '@/common/api/usePrivateAxios';
import { useMutation } from '@tanstack/react-query';
import type { AxiosError, AxiosResponse } from 'axios';

export interface Props {
  establishmentCompanyBranchId?: string;
  onSuccess?: (response: AxiosResponse) => void
  onError?: (error: AxiosError) => void
}

type MutationProps = {
  blobId: string;
}

const useUpdateEstablishmentCompanyBranchImage = ({
  establishmentCompanyBranchId,
  onSuccess,
  onError,
}: Props) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['updateEstablishmentCompanyBranchImage', establishmentCompanyBranchId],
    mutationFn: async ({ blobId }: MutationProps) => {
      const payload = {
        company_branch: {
          photos_attachments_attributes: [
            { blob_id: blobId }
          ]
        }
      }

      return await privateAxios.put(
        `/establishment/company_branches/${establishmentCompanyBranchId}`,
        payload
      )
    },
    onSuccess,
    onError,
  })
}

export default useUpdateEstablishmentCompanyBranchImage;